var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"production"},_vm._l((_vm.production),function(p,i){return _c('p',{key:i,staticClass:"georgia text-xl leading-relaxed text-center pb-4",class:i === 0 ? 'font-extrabold' : 'italic'},[_vm._v(" "+_vm._s(p)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }